import { render, staticRenderFns } from "./moduleTree.vue?vue&type=template&id=722a4058&scoped=true"
import script from "./moduleTree.vue?vue&type=script&lang=js"
export * from "./moduleTree.vue?vue&type=script&lang=js"
import style0 from "./moduleTree.vue?vue&type=style&index=0&id=722a4058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a4058",
  null
  
)

export default component.exports